import { OnDestroy, Directive } from '@angular/core';

import { Subject } from 'rxjs';


@Directive()
export class DestroyableComponent implements OnDestroy{

	protected _unsubscribeAll = new Subject();

	ngOnDestroy(): void{
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}
}
